import { messaging } from 'types';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';
import protos from 'utils/protos';

const { NotifyRequest } = protos;

export function sendNotification(request: messaging.INotifyRequest): ApiAction {
  return {
    TockApi: {
      postProto: `/internal/notify`,
      type: ClowncarAppConstants.NULL,
      request: NotifyRequest.fromObject(request),
    },
  };
}
